// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-message {
  font-size: 14px;
  background-color: var(--primary-color-light-500);
  padding: 5px;
  border-radius: 10px;
  display: flex;
  flex-flow: row !important;
  align-items: center;
  justify-content: center;
  color: var(--primary-color-500);
  gap: 5px;
}
.info-message .material-icons {
  color: var(--accent-color-1);
}
.info-message span {
  margin-top: 0;
}
.info-message::after {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Commons/InfoMessage/InfoMessage.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gDAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,QAAA;AACF;AACE;EACE,4BAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,aAAA;AADJ","sourcesContent":[".info-message {\n  font-size: 14px;\n  background-color: var(--primary-color-light-500);\n  padding: 5px;\n  border-radius: 10px;\n  display: flex;\n  flex-flow: row !important;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary-color-500);\n  gap: 5px;\n\n  .material-icons {\n    color: var(--accent-color-1);\n  }\n\n  span {\n    margin-top: 0;\n  }\n\n  &::after {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
